import {Box,Tabs, TabList, Tab, TabPanels,TabPanel,Divider, ButtonGroup, Button, SkeletonCircle, SkeletonText, useToast, FormLabel, Select,
Input,InputGroup, InputRightElement, NumberInput, NumberInputField, TableContainer,Table,Th,Tr,Td,Thead,Tbody,  IconButton,Text,Modal,
ModalContent,ModalHeader,ModalFooter,ModalBody} from '@chakra-ui/react';
import {MdPerson, MdLocationOn, MdAdd,MdCancel,MdSaveAlt} from 'react-icons/md';
import {GiWeight} from 'react-icons/gi'
import {DeleteIcon, SmallCloseIcon} from '@chakra-ui/icons';
import { useState, useEffect, useRef } from 'react';
import { getKnjige } from "../../util/apiKnjiga";
import {getDokumentTip, getOdlazakByMigracijaId} from '../../util/apiMigracija'
import Dokument from '../custom/Dokument';
import OsobaSelect from '../osoba/OsobaSelect';
import GovedaList from '../govedo/GovedaList';
import GruntPager from '../custom/GruntPager';
import KnjigaSelect from '../knjiga/KnjigaSelect';
import {Govedo, OdlazakData, Osoba, loggedOper} from '../../util/grunt';


export default function Odlazak({_canSave=true,odlazak_tip_sifra="OKLA",onClose,onSave,onDelete,newOdlazak=true,readonly=false,odlazakMigracijaId=0,isMigracijaView=false,size='xs'}) {
    const [dataisloading,setDataIsLoading]=useState(true);
    const [odlazak,setOdlazak]=useState({zivbrpattern:"",dokumentTipovi:[],knjige:[],lokacije:[],odlazakData:new OdlazakData()});
    const [govstate,setGovstate]=useState({/*goveda:[],*/govedoAdd:false,selectedGovEdit:false,govedoSelected:{}});
    const [posjednik,setPosjednik]=useState({selectPosjednik:false});
    const [deletedata,setDeleteData]=useState(false);
    const [fetchFinished,setFetchFinished]=useState(false);
    const [odlazaktipsifra,setOdlazakTipSifra]=useState(odlazak_tip_sifra);
    //const [brgrla,setBrgrla]=useState(1);
    
    const [showselectgoveda, setShowselectgoveda] = useState(false);
    const [prikaz, setPrikaz] = useState({rowsperpage:15,currpage:1})
    const toast=useToast();
    const knjigeRef=useRef(null);
    
//
const fetchData=async()=>{
    try {
            
        const resDoc=await getDokumentTip();
        const resKnj=await getKnjige();
        const _dokumenttipovi=resDoc.res.filter(item=>item.migracija_tip_sifra===odlazaktipsifra);
        
        if (resKnj.status===200) {
            if (newOdlazak) {
                const _odld=new OdlazakData();
                _odld.migracija_tip_sifra=odlazaktipsifra;
                _odld.knjiga_id=resKnj.res[0].id;
                _odld.lokacija=resKnj.res[0].lokacija;
                _odld.odjeljak_id=resKnj.res[0].odjeljak_id;
                _odld.posjednik_naziv=resKnj.res[0].posjednik_naziv;
                _odld.vlasnik_naziv=resKnj.res[0].vlasnik_naziv;
                _odld.dokument_tip_id=_dokumenttipovi[0].dokument_tip_id
                _odld.goveda=[];
                //setOdlazak({...odlazak,knjige:resKnj.res,dokumentTipovi:_dokumenttipovi,odlazakData:{...odlazak.odlazakData,knjiga_id:resKnj.res[0].id,lokacija:resKnj.res[0].lokacija, posjednik_naziv:resKnj.res[0].posjednik_naziv,vlasnik_naziv:resKnj.res[0].vlasnik_naziv,dokument_tip_id:_dokumenttipovi[0].dokument_tip_id,odjeljak_id:resKnj.res[0].odjeljak_id}});            
                setOdlazak({...odlazak,knjige:resKnj.res,dokumentTipovi:_dokumenttipovi,odlazakData:_odld})
            } else {
                const _r=await fetchOdlazakDataForEdit();
                setOdlazak({...odlazak,odlazakData:_r,dokumentTipovi:_dokumenttipovi,knjige:resKnj.res});  
            
            }
            
            
        } else {
            throw new Error(resDoc.message);
        }
        
    } catch (error) {
        toast({
            title:"Greška kod dohvata podataka (unos odlaska).",
            status:"error",
            description:error.message,
            isClosable:true,
            duration:2000,
            position:"top-right",
        });
    } finally {
        setDataIsLoading(false);
        setFetchFinished(true);
    }
    
}

const fetchOdlazakDataForEdit=async ()=>{
    if (odlazakMigracijaId!==0) {
        try {
            const res=await getOdlazakByMigracijaId(odlazakMigracijaId);
            if (res.status===200 && res.res.length>0) {
                
                let _govedo;
                let goveda=[];
                //dolazak
                
                const _d=new OdlazakData();
                _d.knjiga_id=res.res[0].prijasnja_knjiga_id;
                _d.datum=res.res[0].datum;
                _d.ijr=res.res[0].ijr;
                _d.dokument_tip_id=res.res[0].dokument_tip_id;
                _d.dokument_broj=res.res[0].dokument_broj;
                _d.lokacija=res.res[0].prijasnja_lokacija;
                _d.posjednik_naziv=res.res[0].prijasnji_posjednik_naziv;
                _d.vlasnik_naziv=res.res[0].prijasnji_vlasnik_naziv;
                _d.uktezina=res.res[0].tezina;
                _d.brgrla=parseInt(res.res[0].br_grla);
                _d.migracijaKnjigaId=res.res[0].migracija_knjiga_id;
                _d.jibg=res.res[0].jibg;
                //odlazaktipsifra
                setOdlazakTipSifra(res.res[0].odlazak_tip_sifra);
                //posjednik
                const _p=new Osoba();
                _p.id=res.res[0].novi_posjednik_id;
                _p.naziv=res.res[0].novi_posjednik_naziv;
                _p.mjesto=res.res[0].novi_posjednik_mjesto;
                _p.ulkbr=res.res[0].novi_posjednik_ulkbr;
                _p.drzava=res.res[0].novi_posjednik_drzava;
                _p.sifra=res.res[0].novi_posjednik_sifra;
                _p.postanaziv=res.res[0].novi_posjednik_posta;
                _p.pbr=res.res[0].novi_posjednik_pbr;
                //goveda
                res.res.forEach((g)=>{
                    //_govedo=new Govedo(g.govedo_id,g.zivbr,g.ime,g.datrod,g.spol,g.mzivbr,g.ozivbr,g.gov_odjeljak_id,g.rfid,g.pasmina_sifra,g.pasmina_naziv);
                    _govedo=new Govedo({govedo_id:g.govedo_id,zivbr:g.zivbr,spol:g.spol,ime:g.ime,datrod:g.datrod,mzivbr:g.mzivbr,ozivbr:g.ozivbr,odjeljak_id:g.gov_odjeljak_id,rfid:g.rfid,pasmina_sifra:g.pasmina_sifra,pasmina_naziv:g.pasmina_naziv})
                    //_govedo=new Govedo({govedo_id:g.govedo_id,zivbr:g.zivbr,ime:g.ime,datrod:g.datrod,spol:g.spol,mzivbr:g.mzivbr,ozivbr:g.ozivbr,odjeljak_id:g.odjeljak_id,rfid:g.rfid,pasmina_sifra:g.pasmina_sifra,pasmina_naziv:g.pasmina_naziv});
                    _govedo.datum_dolazak=g.datum_dolazak;
                    _govedo.putnica_oznaka=g.putnica_oznaka;
                    goveda.push(_govedo);
                })
                _d.goveda=goveda;
                _d.migracijaPosjednik=_p;
                return _d
                
            } else {
                if (res.status===200 && res.res.length===0) {
                    throw new Error("Podaci migracije nisu dohvaćeni iz baze.");
                } else {
                    throw new Error(res.message);
                }

                
            }
        } catch (error) {
            toast({
                title:"Greška kod dohvata podataka (pregled migracije).",
                status:"error",
                description:error.message,
                isClosable:true,
                duration:2000,
                position:"top-right",
            });
        }
    }
    
}

useEffect(() => {
  fetchData();

  if (knjigeRef.current) {
    knjigeRef.current.focus();  
  }
  
}, [])


const getTabCaptionForPosjednik=()=>{
    let _res="";
    switch (odlazaktipsifra) {
        case "OPROD":
            _res="Posjednik";
            break;
        case "OIZVZ":
            _res="Posjednik";
            break;
        case "OKLA":
            _res="Klaonica";
            break;
        case "OMIK":
            _res="Nova knjiga/farma";
            break;
        case "OIZGB":
            _res="Posjednik";
            break;
        default:
            _res="Posjednik";
            break;
    }
    return _res;
    
}
const onKnjigaChange=(event)=>{
    const _knjiga=odlazak.knjige.filter(item=>item.id.toString()===event.target.value);
    if (_knjiga.length===1) {
        //setDolazak({...dolazak,selectedKnjiga:_knjiga[0]});
        const _odld=odlazak.odlazakData;
        _odld.knjiga_id=event.target.value;
        _odld.lokacija=_knjiga[0].lokacija;
        _odld.odjeljak_id=_knjiga[0].odjeljak_id;
        _odld.posjednik_naziv=_knjiga[0].posjednik_naziv;
        _odld.vlasnik_naziv=_knjiga[0].vlasnik_naziv;
        _odld.goveda=[];
        
        //setOdlazak({...odlazak,odlazakData:{...odlazak.odlazakData,knjiga_id:event.target.value,lokacija:_knjiga[0].lokacija,
         //   odjeljak_id:_knjiga[0].odjeljak_id,posjednik_naziv:_knjiga[0].posjednik_naziv,vlasnik_naziv:_knjiga[0].vlasnik_naziv}});
         setOdlazak({...odlazak,odlazakData:_odld});
        setShowselectgoveda(false);
        setGovstate({...govstate,goveda:[]});
    }
}
const onValueChange=(event)=>{
    //const _odld=this.state.odlazak.odlazakData;
    const _odld=odlazak.odlazakData;
    switch (event.target.id.toLowerCase()) {
        
        case "iddatum":
            if (event.target.value!=="") {
                const _d=new Date(event.target.value);
            _d.setDate(_d.getDate()+1);
            
            _odld.datum=event.target.value;
            _odld.ijr=_d.toISOString().split("T")[0];
            //setOdlazak({...odlazak,odlazakData:{...odlazak.odlazakkData,datum:event.target.value,ijr:_d.toISOString().split("T")[0]}})
            setOdlazak({...odlazak,odlazakData:_odld})
              
            }
            break;  
        case "idijr":
            _odld.ijr=event.target.value;;
            //setOdlazak({...odlazak,odlazakData:{...odlazak.odlazakData,ijr:event.target.value}})
            setOdlazak({...odlazak,odlazakData:_odld})
            break;
        case "idjibg":
            _odld.jibg=event.target.value.toUpperCase();
            setOdlazak({...odlazak,odlazakData:_odld})
            break;
        /*case "iduktezina":
            setOdlazak({...odlazak,odlazakData:{...odlazak.odlazakData,uktezina:event.target.value}})
            break;
        
        case "idbrgrla":
            if (isNaN(event.target.value)) {
                setOdlazak({...odlazak,odlazakData:{...odlazak.odlazakData,brgrla:0}});    
            }
            else {
                setOdlazak({...odlazak,odlazakData:{...odlazak.odlazakData,brgrla:Number(event.target.value)}});
            }
            
            break;*/
        default:
            break;
    }
}

const onSelectPosjednik=(posjednik)=>{
    let _odld=odlazak.odlazakData;
    _odld.migracijaPosjednik=posjednik;
   setOdlazak({...odlazak,odlazakData:_odld})
   setPosjednik({...posjednik,selectedPosjednik:false})
    //setPosjednik({...posjednik,selectedPosjednik:posjednik,selectPosjednik:false,selectedNovKnjigaId:0})
}

const showTabPosjednik=()=>{
    let __subjtipid="";
    let _naslov="";
    switch (odlazaktipsifra) {
        case "OPROD":
            __subjtipid="os";
            _naslov="Domaći partneri";
            break;
        case "OIZVZ":
        __subjtipid="so";
        _naslov="Strani partneri";
            break;
        case "OKLA":
            __subjtipid="kl";
            _naslov="Klaonice";
                break;
        case "OMIK":
            __subjtipid="";
            _naslov="Knjige/Farme";
            break;
        default:
            _naslov="Partneri";
            __subjtipid="";
            break;
    }
    
    if (dataisloading) {
        return (

            <Box display={'flex'} flexDir={'column'} gap={'0.5rem'} w='100%'>
                <SkeletonCircle size='10' />
                <SkeletonText mt='4' noOfLines={10} spacing='4' skeletonHeight='2' />
            </Box>
        )
    } else {
    if (posjednik.selectPosjednik) {
        return (<OsobaSelect onSelect={onSelectPosjednik} naslov={_naslov} subjekttipid={__subjtipid} onClose={()=>setPosjednik({...posjednik,selectPosjednik:false})} size={size}/>);    
    } 
     else {
        return (
            <Box display={'flex'} flexDir={'column'} gap={'0.5rem'} w='100%'>
                <Box mt={'0.5rem'}>
                    <Button isDisabled={readonly} rightIcon={<MdPerson/>} size={size} colorScheme={'grunt2'} variant={'outline'} onClick={()=>{setPosjednik({...posjednik,selectPosjednik:true})}}>Odaberi</Button>
                </Box>
                <Box display={'flex'} flexDir={'row'} w={'100%'} gap={'0.5rem'}>
                    <Box w={'50%'}>
                        <FormLabel fontSize={size}>Šifra</FormLabel>
                        <Input focusBorderColor='grunt2.400' isReadOnly tabIndex={-1} size={size} variant={'filled'}  display={'block'} value={odlazak.odlazakData.migracijaPosjednik.sifra}/>
                    </Box>
                    <Box w={'50%'}>
                        <FormLabel fontSize={size}>Naziv</FormLabel>
                        <Input focusBorderColor='grunt2.400' isReadOnly tabIndex={-1} size={size} variant={'filled'}  display={'block'} value={odlazak.odlazakData.migracijaPosjednik.naziv}/>
                    </Box>
                </Box>
                <Box display={'flex'} flexDir={'row'} w={'100%'} gap={'0.5rem'}>
                    <Box w={'50%'}>
                        <FormLabel fontSize={size}>Mjesto</FormLabel>
                        <Input focusBorderColor='grunt2.400' isReadOnly tabIndex={-1} size={size} variant={'filled'} display={'block'} value={odlazak.odlazakData.migracijaPosjednik.mjesto}/>
                    </Box>
                    <Box w={'50%'}>
                        <FormLabel fontSize={size}>Ulica i kbr.</FormLabel>
                        <Input focusBorderColor='grunt2.400' isReadOnly tabIndex={-1} size={size} variant={'filled'} display={'block'} value={odlazak.odlazakData.migracijaPosjednik.ulkbr}/>
                    </Box>
                </Box>
                <Box display={'flex'} flexDir={'row'} w={'100%'} gap={'0.5rem'}>
                    <Box w={'50%'}>
                        <FormLabel fontSize={size}>Pošta</FormLabel>
                        <Input focusBorderColor='grunt2.400' isReadOnly tabIndex={-1} size={size} variant={'filled'} display={'block'} value={odlazak.odlazakData.migracijaPosjednik.posta}/>
                    </Box>
                    <Box w={'50%'}>
                        <FormLabel fontSize={size}>Država</FormLabel>
                        <Input focusBorderColor='grunt2.400' isReadOnly tabIndex={-1} size={size} variant={'filled'} display={'block'} value={odlazak.odlazakData.migracijaPosjednik.drzava}/>
                    </Box>
                </Box>
                <Box display={'flex'} flexDir={'row'} w={'100%'} gap={'0.5rem'}>
                        <Box w={'50%'}>
                            <FormLabel fontSize={size}>JIBG</FormLabel>
                            <Input focusBorderColor='grunt2.400' isReadOnly={readonly} maxLength={11} isDisabled={odlazaktipsifra==="OPROD"?false:true} id="idJIBG" size={size}  variant={'outline'}  display={'block'} value={odlazak.odlazakData.jibg} onChange={onValueChange}/>
                        </Box>
                        <Box w={'50%'}>
                            
                        </Box>
                    </Box>
            </Box>
        )
    }
    }
    

}

const numberInputChaged=(vStr,vNum)=>{
    const _odld = odlazak.odlazakData;
    _odld.uktezina=vStr;
    //setOdlazak({...odlazak,odlazakData:{...odlazak.odlazakData,uktezina:vStr}})
    setOdlazak({...odlazak,odlazakData:_odld});
    //setUktezina(vStr);
}
const brGrlaInputChanged=(vStr,vNum)=>{
    //const _odld = odlazak.odlazakData;
    //_odld.brgrla=vStr;
    //setOdlazak({...odlazak,odlazakData:_odld});
    setOdlazak({...odlazak,odlazakData:{...odlazak.odlazakData,brgrla:vNum}})
    //setBrgrla(vNum);
}

const onDokumentTipIdChanged=(id)=>{
    const _odld = odlazak.odlazakData;
    _odld.dokument_tip_id=id;
    setOdlazak({...odlazak,odlazakData:_odld});
    //setOdlazak({...odlazak,odlazakkData:{...odlazak.odlazakData,dokument_tip_id:id}})
}

const onDokumentBrChange=(br)=>{
    const _odld = odlazak.odlazakData;
    _odld.dokument_broj=br;
    setOdlazak({...odlazak,odlazakData:_odld});
    //setOdlazak({...odlazak,odlazakData:{...odlazak.odlazakData,dokument_broj:br}})
}

const showKnjige=()=>{
  
    if (odlazak.odlazakData!==undefined) {
        return (
            <Box display={'flex'} flexDir={'column'} gap={'0.5rem'} w={'100%'}>
                <Box display={'flex'} flexDir={'row'} gap={'0.5rem'} w={'100%'}>
                    <Box w={'50%'}>
                        <FormLabel fontSize={size}>Knjiga (farma)</FormLabel>
                        <Select focusBorderColor='grunt2.400' size={size} isDisabled={readonly} variant={'filled'} maxLength={50} onChange={onKnjigaChange} ref={knjigeRef} id='slctKnjiga' value={odlazak.odlazakData.knjiga_id}>
                        {Array.isArray(odlazak.knjige)?odlazak.knjige.map((item,i)=>{
                                return (<option key={i} value={item.id}>{item.naziv}</option>)
                        }):""}
                        </Select>
                    </Box>
                    <Box w={'50%'}>
                        <FormLabel fontSize={size}>Lokacija</FormLabel>
                            <InputGroup size={size}>
                                <InputRightElement pointerEvents={'none'} children={<MdLocationOn/>}/>
                                <Input focusBorderColor='grunt2.400' tabIndex={-1} variant={'outline'} isReadOnly placeholder='Lokacija' value={odlazak.odlazakData.lokacija} display={'block'}/>
                            </InputGroup>
                    </Box>
                </Box>
                <Box display={'flex'} flexDir={'row'} gap={'0.5rem'} w={'100%'}>
                    <Box  w={'50%'}>
                        <FormLabel fontSize={size}>Posjednik</FormLabel>
                        <InputGroup size={size}>
                            <InputRightElement pointerEvents={'none'} children={<MdPerson/>}/>
                            <Input focusBorderColor='grunt2.400' tabIndex={-1} variant={'outline'} isReadOnly placeholder='Posjednik' value={odlazak.odlazakData.posjednik_naziv} display={'block'}/>
                        </InputGroup>
                    </Box>
                    
                    <Box w={'50%'}>
                        <FormLabel fontSize={size}>Vlasnik</FormLabel>
                        <InputGroup size={size}>
                            <InputRightElement pointerEvents={'none'} children={<MdPerson/>}/>
                            <Input focusBorderColor='grunt2.400' tabIndex={-1} variant={'outline'} isReadOnly placeholder='Vlasnik' value={odlazak.odlazakData.vlasnik_naziv} display={'block'}/>
                        </InputGroup>
                    </Box>
                </Box>
            </Box>
        )
    }
    

}
const showTabOdlazak=()=>{
    if (dataisloading) {
        return (

            <Box display={'flex'} flexDir={'column'} gap={'0.5rem'} w='100%'>
                <SkeletonCircle size='10' />
                <SkeletonText mt='4' noOfLines={10} spacing='4' skeletonHeight='2' />
            </Box>
        )
    } else {

    if (odlazak.odlazakData!==undefined) {
        return (
            <Box display={'flex'} flexDir={'column'} gap={'0.5rem'} w='100%'>
                <Box display={'flex'} flexDir={'row'} gap={'0.2rem'}>
                    {showKnjige()}
                </Box>
                <Box>
                    <Dokument readonly={readonly} migracija_tip_sifra={odlazaktipsifra} dokumenti={odlazak.dokumentTipovi} defaultDokumentTipId={odlazak.odlazakData.dokument_tip_id} defaultDokumentBroj={odlazak.odlazakData.dokument_broj} onDokumentTipIdChange={onDokumentTipIdChanged} onDokumentBrChange={onDokumentBrChange}/>
                </Box>
                <Box display={'flex'} flexDir={'column'} w={'100%'} gap={'0.5rem'}>
                    <Box display={'flex'} flexDir={'row'} w={'100%'} gap={'0.5rem'}>
                        <Box w={'50%'}>
                            <FormLabel fontSize={size}>Datum</FormLabel>
                            <Input focusBorderColor='grunt2.400' id="idDatum" size={size}  type="date" variant={'filled'}  display={'block'} value={odlazak.odlazakData.datum} onChange={onValueChange}/>
                        </Box>
                        <Box w={'50%'}>
                            <FormLabel fontSize={size}>Isporučeno u jedinstveni registar</FormLabel>
                            <Input focusBorderColor='grunt2.400' id="idIjr" size={size}  type="date" variant={'filled'}  display={'block'} value={odlazak.odlazakData.ijr} onChange={onValueChange}/>
                        </Box>
                    </Box>
                    <Box display={'flex'} flexDir={'row'} w={'100%'} gap={'0.5rem'}>
                        <Box w={'50%'}>
                            <FormLabel fontSize={size}>Broj grla u migraciji</FormLabel>
                                <InputGroup size={size}>
                                    <NumberInput focusBorderColor='grunt2.400' isDisabled={odlazaktipsifra==="DTELJ"}  onChange={brGrlaInputChanged}  /*value={brgrla}*/ value={odlazak.odlazakData.brgrla} id="idbrgrla" defaultValue={1} min={1}  max={999999} precision={0} w={'100%'}>
                                        <InputRightElement pointerEvents={'none'} fontSize='1.2rem' fontWeight={'bold'} children={"#"}/>            
                                        <NumberInputField id="idbrgrla1" placeholder='Broj grla' variant={'filled'}  display={'block'} />
                                    </NumberInput>
                                </InputGroup>
                        </Box>
                    <Box w={'50%'}>
                        <FormLabel fontSize={size}>Ukupna težina</FormLabel>
                            <InputGroup size={size}>
                                <NumberInput focusBorderColor='grunt2.400' id="iduktezina" defaultValue={"1"} onChange={numberInputChaged}  /*value={uktezina}*/ value={odlazak.odlazakData.uktezina}  min={0}  max={999999} precision={2} w={'100%'}>
                                    <InputRightElement pointerEvents={'none'} children={<GiWeight/>}/>            
                                    <NumberInputField id="iduktezina1"  placeholder='Ukupna težina'  variant={'filled'}  display={'block'} />
                                </NumberInput>
                            </InputGroup>
                    </Box>
                    </Box>
                    <Box display={'flex'} flexDir={'row'} w={'100%'} gap={'0.5rem'}>
                        <Box w={'50%'}>
                            
                        </Box>
                        <Box w={'50%'}>
                            <FormLabel fontSize={size}>Pojedinačna težina</FormLabel>
                            <InputGroup size={size}>
                                <InputRightElement pointerEvents={'none'} children={<GiWeight/>}/>            
                                <Input focusBorderColor='grunt2.400' tabIndex={-1} variant={'outline'} isReadOnly placeholder='Pojedinačna težina' value={odlazak.odlazakData.brgrla===0?"0.00":(parseInt(odlazak.odlazakData.uktezina)/parseInt(odlazak.odlazakData.brgrla)).toFixed(2)} display={'block'}/>
                            </InputGroup>
                        </Box>
                    </Box>
                </Box>
           
            </Box>
            )
    }        
    }
}
//
const saveOdlazak=()=>{
    onSave(odlazak.odlazakData);

}

const canSaveData=()=>{
    if (fetchFinished) {
        if (_canSave===false || readonly || odlazak.odlazakData.goveda.length===0 ||(odlazak.odlazakData.goveda.length!==odlazak.odlazakData.brgrla) || ((odlazak.odlazakData.migracijaPosjednik.id===0 && posjednik.selectedNovKnjigaId===0) && odlazaktipsifra!=="OIZGB") ) {
            return false;
        } else {
            if ((odlazaktipsifra==="OIZVZ" || odlazaktipsifra==="OPROD" || odlazaktipsifra==="OKLA") && odlazak.odlazakData.migracijaPosjednik.id===0) {
                return false;
            } else {
                return true;
        }    }
    } else {
        return false;
    }
    
}
const showButtonDodaj=()=>{
    //dolazak_tip_sifra
    
    return (<Button isDisabled={readonly} rightIcon={<MdAdd/>} size={size} colorScheme={'grunt2'} variant={'outline'} onClick={()=>setShowselectgoveda(!showselectgoveda)}>Odaberi</Button>)
}
const deleteGovedoFromSelection=(govid)=>{
    if (!readonly) {
        const _ar=odlazak.odlazakData.goveda.filter((gov)=>{return gov.govedo_id!==govid});
        const _odld=odlazak.odlazakData;
        _odld.goveda=_ar;
        //setGovstate({...govstate,goveda:_ar});    
        setOdlazak({...odlazak,odlazakData:_odld});
    }
    
}
const showSelectedGoveda=()=>{
    return (
        <>
            <TableContainer>
                        <Table size='xs'>
                            <Thead _hover={{cursor:'pointer'}}>
                                <Tr>
                                    
                                    <Th fontSize={size} textAlign={'center'} zIndex='5' pos={'sticky'} top='0' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'} borderTopLeftRadius={'sm'}></Th>
                                    <Th fontSize={size} textAlign={'center'} zIndex='5' pos={'sticky'} top='0' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Živ.br</Th>
                                    <Th fontSize={size} textAlign={'center'} zIndex='5' pos={'sticky'} top='0' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Spol</Th>
                                    <Th fontSize={size} textAlign={'center'} zIndex='5' pos={'sticky'} top='0' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Dat. dolazak</Th>
                                    <Th fontSize={size} textAlign={'center'} zIndex='5' pos={'sticky'} top='0' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Rfid</Th>
                                    <Th fontSize={size} textAlign={'center'} zIndex='5' pos={'sticky'} top='0' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Oznaka</Th>
                                    <Th fontSize={size} textAlign={'center'} zIndex='5' pos={'sticky'} top='0' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Pasmina</Th>
                                    
                                </Tr>
                            </Thead>
                            <Tbody>
                                {odlazak.odlazakData.goveda.slice((prikaz.currpage-1)*prikaz.rowsperpage,(prikaz.currpage)*prikaz.rowsperpage).map((item,index)=>{
                                    
                                        return (
                                            <Tr  color={'grunt2'} key={item.zivbr}  bg={'white'} fontWeight={'normal'} 
                                                    _hover={{bg:'gray.100'}} h={'2rem'} /*onClick={(zivbr)=>setGovedoForEdit(item.zivbr)}*/>
                                                        <Td fontSize={size}>
                                                            {/* <Menu>
                                                                <MenuButton
                                                                    as={IconButton}
                                                                    aria-label='Options'
                                                                    icon={<SmallCloseIcon color='red' />}
                                                                    variant='outline' size={'xs'} colorScheme='grunt2' rounded={'full'}
                                                                    onClick={()=>deleteGovedoFromSelection(item.govedo_id)}
                                                                />
                                                            </Menu> */}
                                                            <IconButton isDisabled={readonly} size={'0.5rem'} rounded={'full'} bg={'transparent'} variant={'outline'} _hover={{bg:'gray.300'}}
                                                            icon={<SmallCloseIcon color={'red'}/>} onClick={()=>deleteGovedoFromSelection(item.govedo_id)}/>
                                                            
                                                        </Td>
                                                        <Td fontSize={size} textAlign={'center'}>{item.zivbr}</Td>
                                                        <Td fontSize={size}  textAlign={'center'}>{item.spol.toLowerCase()==="m"?"M":"Ž"}</Td>
                                                        <Td fontSize={size} textAlign={'center'}>{new Date(item.datum_dolazak).toLocaleDateString('hr-HR')}</Td>
                                                        <Td fontSize={size} textAlign={'center'}>{item.rfid}</Td>
                                                        <Td fontSize={size} textAlign={'center'}>{item.putnica_oznaka}</Td>
                                                        <Td fontSize={size} textAlign={'center'}>{item.pasmina_naziv}</Td>
                                                    </Tr>
                                        )    
                                    
                                    
                                })}
                            </Tbody>
                        </Table>
                    </TableContainer>
                    {showBrOdabranih()}
                    <GruntPager currpage={prikaz.currpage} rowcount={odlazak.odlazakData.goveda.length} rowsperpage={prikaz.rowsperpage} onClick={(pagenum)=>setPrikaz({...prikaz,currpage:pagenum})}/>
        </>
    )
}
const showBrOdabranih=()=>{
    return (
      <Text fontSize={'xs'}>Odabrano goveda: {odlazak.odlazakData.goveda.length}</Text>
    
    
    )
  }
const onGovedaSelected=(_goveda)=>{
    const _odld=odlazak.odlazakData;
    //const _gov=odlazak.odlazakData.goveda.concat(_goveda);
    _odld.goveda=_goveda;
    setOdlazak({...odlazak,odlazakData:_odld})
    //setGovstate({...govstate,goveda:_goveda});
    setShowselectgoveda(false);
}

const getGovedoIdOfSelected=()=>{
    let _ar=[];
    odlazak.odlazakData.goveda.forEach((gov)=>{_ar.push(gov.govedo_id)});

    return _ar;
}

const deleteOdlazak=()=>{
    onDelete(odlazakMigracijaId);
    setDeleteData(false);
}

const onDolaznaKnjigaChange=(knjiga_id)=>{
    const _odld=odlazak.odlazakData;
    _odld.migracijaKnjigaId=knjiga_id;
    setOdlazak({...odlazak,odlazakData:_odld});
    
}
const showKnjigeForSelect=()=>{
    if (odlazak.odlazakData.knjiga_id>-1) {
        if (odlazaktipsifra==="OMIK") {
            if (odlazak.odlazakData.migracijaKnjigaId>0) {
                return (<KnjigaSelect onKnjigaChange={onDolaznaKnjigaChange} readonly={readonly} preselectedKnjiga={odlazak.odlazakData.migracijaKnjigaId} />)    
            } else {
                return (<KnjigaSelect onKnjigaChange={onDolaznaKnjigaChange} readonly={readonly} />)
            }    
        }    
    }
}

const potvrdiBrisanje=()=>{
    if (deletedata) {
        return (
            <>
                <Modal isOpen={true} size={'sm'}>
        
        <ModalContent>
          <ModalHeader color={'grunt2'}>Grunt.RGG</ModalHeader>
          
          <ModalBody>
            Jeste li sigurni da želite obrisati podatke odlaska?
          </ModalBody>

          <ModalFooter>
            <Button colorScheme='grunt2' variant={'solid'} mr={3} size={'sm'} onClick={deleteOdlazak}>
              Da
            </Button>
            <Button colorScheme='grunt2' variant={'outline'} mr={3} size={'sm'} onClick={()=>{setDeleteData(false)}}>
              Ne
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
            </>
        )
    }
  }  


const showTabGoveda=()=>{
    if (dataisloading) {
        return (

            <Box display={'flex'} flexDir={'column'} gap={'0.5rem'} w='100%'>
                <SkeletonCircle size='10' />
                <SkeletonText mt='4' noOfLines={10} spacing='4' skeletonHeight='2' />
            </Box>
        )
    } else {

    return (
        <Box display={'flex'} flexDir={'column'} gap={'0.5rem'} w='100%'>
                    <Box mt={'0.5rem'}>
                        {showButtonDodaj()}   
                    </Box>
                    {showselectgoveda?
                <GovedaList  knjiga_id={odlazak.odlazakData.knjiga_id} naslov={"Odabir goveda"} onSubmitSelected={onGovedaSelected} onClose={()=>setShowselectgoveda(false)} preselectedgoveda={getGovedoIdOfSelected()} omigracijaid={odlazakMigracijaId}/>:
                showSelectedGoveda()
            }
            
        </Box>
    //     
    )
}
}
  return (
    <Box>
        <Tabs variant='enclosed' minH={'70vh'} h={'100%'} overflow={'auto'} size={'sm'} colorScheme='grunt2'>
        <TabList>
            <Tab _focus={{fontWeight:'bold'}}>Odlazak</Tab>
            <Tab _focus={{fontWeight:'bold'}} isDisabled={odlazaktipsifra==="OIZGB" || odlazaktipsifra==="OUGIN"}>{getTabCaptionForPosjednik()}</Tab>
            {loggedOper.uloga==="r"?null:<Tab _focus={{fontWeight:'bold'}}>Goveda</Tab>}
        </TabList>
        <TabPanels>
            <TabPanel>
            {showTabOdlazak()} 
            {potvrdiBrisanje()}
            </TabPanel>
            <TabPanel>
                {odlazaktipsifra==="OMIK"?showKnjigeForSelect():showTabPosjednik()}
            </TabPanel>
            {/* {
            !isMigracijaView?
            <TabPanel>
                {showTabGoveda()}
            </TabPanel>:
            <></>
            } */}
            <TabPanel>
                {showTabGoveda()}
            </TabPanel>
        </TabPanels>
    </Tabs>
    <Divider orientation='horizontal'/>
    {isMigracijaView?<></>:
    <Box display={'flex'} flexDir={'row'} m={'1rem'} w='100%'>
        <ButtonGroup gap={'1rem'} mr={'10rem'}>
            
            <Button isDisabled={!canSaveData()} rightIcon={<MdSaveAlt/>} type={'submit'} colorScheme={'grunt2'} size={size} onClick={saveOdlazak} >Spremi</Button>
            <Button colorScheme={'grunt2'} rightIcon={<MdCancel/>} variant={'outline'} size={size} onClick={onClose}>Odustani</Button>
            
            
        </ButtonGroup>
        <Button isDisabled={readonly} hidden={newOdlazak}  colorScheme={'red'} rightIcon={<DeleteIcon/>} variant={'outline'} size={size} onClick={()=>{setDeleteData(true)}}>Briši</Button>    
    </Box>
    }
    </Box>

  )
}
